import BaseCadastro from "components/BaseCadastro";
import Transacao from "model/suprimentos/Transacao";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import TransacaoService from "service/suprimentos/TransacaoService";
import "react-hook-form";
import {Controller, useForm} from "react-hook-form";
import { Label } from "components/input/Label";

const transacaoService = new TransacaoService();

export default function TransacaoCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [transacao, setTransacao] = useState<Transacao>(new Transacao());
    const [titulo, setTitulo] = useState<string>('Transação');
    const [editando, setEditando] = useState<boolean>(false);

    useEffect(() => {
        if (!window.location.pathname.includes("cadastrar")) {
            setEditando(true);
        }
    },[])

    function validar() {

        if(!transacao.codigo){
            setError("codigo", {type: "manual", message: "Código é Obrigatório"}, {shouldFocus: true})
            return false;
        }if (!transacao.descricao) {
            setError("descricao", {type: "manual", message: "Descriçào é Obrigatória"}, {shouldFocus: true})
            return false;
        }if (!transacao.tipo) {
            setError("tipo", {type: "manual", message: "Tipo é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={transacao} service={transacaoService} setModel={(value: Transacao) => setTransacao(value)} novoCadastro getNewModel={() => new Transacao()}
            validar={() => validar()} urlService="/transacao" pathCadastro="/transacao" tituloPagina={'Transacao'}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Código</Label>
                <div className="col-sm-12">
                    <InputText 
                        required disabled={editando} 
                        className={errors.codigo ? "p-invalid" : ""}
                        value={transacao.codigo||""} 
                        style={{ width: '100%' }}
                        {...register("codigo", {
                            onChange: (e) => {
                                setTransacao({ ...transacao, codigo: e.target.value })
                                clearErrors("codigo")
                            } 
                        })} 
                    />
                </div>
                {errors.codigo && errors.codigo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.codigo?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                <div className="col-sm-12">
                    <InputText 
                        className={errors.descricao ? "p-invalid" : ""}
                        required value={transacao.descricao} 
                        style={{ width: '100%' }}
                        {...register("descricao", {
                            onChange: (e) => {
                                setTransacao({ ...transacao, descricao: e.target.value })
                                clearErrors("descricao")
                            } 
                        })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>

            <div className="row">
            <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                <div className="col-sm-12">
                    <Controller name="tipo" control={control} render={({field}) => (
                        <Dropdown 
                            focusInputRef={field.ref}
                            options={transacaoService.getTiposTransacao()}
                            className={errors.tipo ? "p-invalid" : ""} 
                            optionLabel="label" optionValue="value"  
                            required 
                            value={transacao.tipo} onChange={(e) => {
                                setTransacao({ ...transacao, tipo: e.target.value })
                                clearErrors("tipo") 
                            }}
                            style={{ width: '100%' }} 
                        />
                    )}/>
                </div>
                {errors.tipo && errors.tipo.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipo?.message as string}</span> : null}
            </div>


        </BaseCadastro>
    )
}
